module.exports = __webpack_public_path__ + "img/advance9.246f0b81.png";